import '@learnforge/demo-kit/styles.css';
import '@learnforge/demo-kit/shell.css';
import '@learnforge/demo-render/styles.css';
import './styles.css';

import { bootstrapDemoShell } from '@learnforge/demo-kit';
import { makePrng } from '@learnforge/demo-math/numeric';
import { EXPERIMENTS, EXPERIMENT_ORDER } from './experiments';
import { i18n } from './i18n';
import type { CalculusContext, ExperimentKey } from './types';

bootstrapDemoShell({
  slug: 'calculus',
  i18n,
  experiments: EXPERIMENTS,
  order: EXPERIMENT_ORDER,
  eyebrowKey: 'app.eyebrow',
  shotToExperiment: (id) =>
    EXPERIMENT_ORDER.includes(id as ExperimentKey) ? (id as ExperimentKey) : null,
  extendContext: (base, { shotId }): CalculusContext => ({
    ...base,
    prng: makePrng(shotId !== null ? 0xca1c01 : Date.now()),
  }),
});
